import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAccessRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-access-redirect',
	path: '/jira/servicedesk/projects/:projectKey/settings/people',
	exact: true,
};
